import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(
    private http: HttpClient,
  ) { }

  getLastOrder(): Observable<any> {
    return this.http.get<any>(`/api/getLastOrder`);
  }

  saveOrder(payload: any): Observable<any> {
    return this.http.post<any>(`/api/createOrder`, payload).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getOrder(usr: any) {
    return this.http.get<any>(`/api/getOrder?usr=${usr}`);
  }

  getListOrder(usr: any) {
    return this.http.get<any>(`/api/getListOrder?usr=${usr}`);
  }
  
  getOrdersToValidate(id: any) {
    return this.http.get<any>(`/api/getOrdersToValidate/${id}`);
  }
  
  getAllOrders() {
    return this.http.get<any>(`/api/getAllOrders`);
  }

  updateOrderStatus(payload: any): Observable<any> {
    return this.http.post<any>(`/api/updateOrderStatus`, payload);
  }

  updatePrice(payload: any): Observable<any> {
    return this.http.post<any>(`/api/updateOrderPrice`, payload);
  }
  updateOrderTracking(payload: any): Observable<any> {
    return this.http.post<any>(`/api/updateOrderTracking`, payload);
  }

  generatePdfQuotation(payload: any): Observable<any> {
    return this.http.post<any>(`/api/generateQuotation`, payload, {responseType: 'blob' as 'json' });
  }

  sendQuotationEmail(payload: any): Observable<any> {
    return this.http.post<any>(`/api/sendQuotation`, payload);
  }
}
